import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportCashBankPDF = ({ groupedData, fromDate, toDate, societyName }) => {

    //const handleDownloadCashBankPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "A4",
    });

    const formatDate = (isoDate) => {
        if (!isoDate) return "";
        const [year, month, day] = isoDate.split("-");
        return `${day}/${month}/${year}`;
    };

    const formatCurrency = (amount) => {
        const numberFormat = new Intl.NumberFormat('en-IN', {
            style: 'decimal', //'currency',
            minimumFractionDigits: 2,
            currency: 'INR',
            currencyDisplay: 'symbol',
        });
        return numberFormat.format(amount);
    }


    const reportTitle = `Cash/Bank Book Report: ${formatDate(fromDate)} to ${formatDate(toDate)}`;
    const reportDateTime = new Date().toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const leftMargin = 14;
    const rightMargin = 14;
    const headerHeight = 30;

    /** ---------- HEADER ---------- **/
    const drawHeader = () => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(societyName, doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.text(reportTitle, doc.internal.pageSize.getWidth() / 2, 23, { align: "center" });
    };

    /** ---------- BUILD TABLE CONTENT ---------- **/
    const allTableSections = [];

    // Grouped data structure: { [bank_name]: [rows...] }
    Object.entries(groupedData).forEach(([bank_name, entries]) => {
      const tableRows = [];

      entries.forEach((e) => {
          
        let cellStyle = {};
        if (e.narration?.toLowerCase().includes("opening balance")) {
          cellStyle = { fontStyle: "bold" };
        } else if (e.narration?.toLowerCase().includes("closing balance")) {
          cellStyle = { fontStyle: "bold", fillColor: [230, 230, 230] }; // 👈 light grey background
        }

        tableRows.push([
          { content: e.vchr_no || "", styles: cellStyle },
          { content: e.vchr_date || "", styles: cellStyle },
          { content: e.payer_payee || "", styles: cellStyle },
          { content: e.narration || "", styles: cellStyle },
          { content: formatCurrency(e.dr_amt) || "", styles: cellStyle },
          { content: formatCurrency(e.cr_amt) || "", styles: cellStyle },
          { content: e.close_bal || "", styles: cellStyle },
        ])

      });

      allTableSections.push({ bank_name, tableRows });
    });

    /** ---------- DRAW TABLES ---------- **/
    let currentY = headerHeight;

    allTableSections.forEach((section, index) => {
      doc.autoTable({
        startY: currentY,
        margin: { top: headerHeight, left: leftMargin, right: rightMargin },
        tableWidth: "auto",
        head: [[
          { content: section.bank_name, colSpan: 7, styles: {  halign: "left", fillColor: [220, 230, 240], fontStyle: "bold" } },
        ]],
        body: [],
        theme: "plain",
        styles: { fontSize: 10 },
        didDrawPage: (data) => {
          if (data.pageNumber === 1 && index === 0) drawHeader();
        },
      });

      doc.autoTable({
        startY: doc.lastAutoTable.finalY,
        margin: { top: headerHeight, left: leftMargin, right: rightMargin },
        head: [["Vchr No", "Date", "Payer/Payee", "Narration", "Debit Amount", "Credit Amount", "Closing Bal."]],
        body: section.tableRows,
        theme: "grid",
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255, halign: "center" },
        columnStyles: {
          0: { halign: "center", cellWidth: 20 },
          1: { halign: "center", cellWidth: 22 },
          2: { cellWidth: 55 },
          3: { cellWidth: 75 },
          4: { halign: "right", cellWidth: 32 },
          5: { halign: "right", cellWidth: 32 },
          6: { halign: "right", cellWidth: 33 },
        },
        didDrawPage: (data) => {
          // Repeat header + footer on each page
          drawHeader();

          const pageWidth = doc.internal.pageSize.getWidth();
          const footerY = doc.internal.pageSize.getHeight() - 10;

          doc.setFontSize(9);
          doc.setDrawColor(150);
          doc.line(leftMargin, footerY - 3, pageWidth - rightMargin, footerY - 3);
          doc.text(`eSchool`, leftMargin, footerY + 2);
          doc.text(`Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`, pageWidth / 2, footerY + 2, { align: "center" });
          doc.text(`Generated on: ${reportDateTime}`, pageWidth - rightMargin, footerY + 2, { align: "right" });
        },
      });

      currentY = doc.lastAutoTable.finalY + 6;
    });

    /** ---------- SAVE ---------- **/
    doc.save(`CashBank_Book_${formatDate(fromDate)}_to_${formatDate(toDate)}.pdf`);
};
